import {
  IconButton,
  ListItem,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import TimeToLeaveSharpIcon from "@mui/icons-material/TimeToLeaveSharp";
import LocationOnSharpIcon from "@mui/icons-material/LocationOnSharp";

import { Costumer } from "../model";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import { UserContext } from "../../../contexts/user/user.context";
import { ACCESS_RULES, canAccess } from "../../../shared/auth/access-control";

interface Props {
  costumers: Costumer[];
}

export const CostumersList: React.FC<Props> = ({ costumers }) => {
  const navigate = useNavigate();
  const { user } = useContext(UserContext);
  const canEditCostumers = canAccess(user?.permission, ACCESS_RULES.COSTUMERS_EDIT);

  return (
    <>
      {costumers.map(({ id, name, address }) => {
        const labelId = `checkbox-list-label-${id}`;

        return (
          <ListItem key={id} divider>
            <ListItemButton
              role={undefined}
              dense
              onClick={canEditCostumers ? () => navigate(`/costumers/${id}`) : undefined}
              aria-disabled={!canEditCostumers}
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                textAlign: "center",
                cursor: canEditCostumers ? "pointer" : "default",
              }}
            >
              <ListItemText
                id={labelId}
                primary={`${name}`}
                sx={{ flex: "1", textAlign: "left" }}
              />
            </ListItemButton>
            <IconButton>
              <a href={address} target="_blank" rel="noreferrer">
                <LocationOnSharpIcon />
              </a>
            </IconButton>
            <IconButton>
              <TimeToLeaveSharpIcon />
            </IconButton>
          </ListItem>
        );
      })}
    </>
  );
};
